




















import { Component, Emit, Prop, Ref, Vue } from "vue-property-decorator";
import GtExportDialog from "@root/components/gt-export-dialog/index.vue";
import { loading, loadingCatch } from "@root/lib/decorator";

@Component({
  components: {
    GtExportDialog
  }
})
@loading()
export default class CustomExportButton extends Vue {
  @Prop({ default: () => {}, type: Object }) params: Object;
  @Prop({ default: false, type: Boolean }) disabled;
  @Prop({ default: () => {}, type: Function }) fn: Function;
  @Prop({ default: () => {}, type: Function }) emptyFn: Function; // 空的
  @Prop({ default: () => {}, type: Function }) closeFn: Function; // 关闭的回调
  @Prop({ default: "0", type: String }) routeParams: String; // 是跟在导出链接后面的参数

  @Ref("gtExportDialog") gtExportDialogRef: any;

  private visible = false;
  // 导出
  @loadingCatch
  exportTable() {
    this.visible = true;
  }

  // @Emit("closeFn")
  // closeFun() {
  //   this.visible = false;
  //   console.log(123);
  // }
  // 
}
